// Api key regestered by luji@demant.com

export var implementRecaptchaTestScript = function implementRecaptchaTestScript() {
  var captcha = document.createElement('script');
  captcha.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=6LdovUgeAAAAAGGQJfCFnA1f9LUbkRzlXVULsdPE');
  document.head.appendChild(captcha);
};
export var getRecaptchApiKey = function getRecaptchApiKey() {
  var _document$querySelect;
  return (_document$querySelect = document.querySelector('script[src*="google.com/recaptcha"]')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.getAttribute('src')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.split('render=')[1];
};